// export const BASE_URL = "http://52.8.210.186/api/v1/"; //dev ip
// export const BASE_URL = "http://204.236.140.219/api/v1/"; //production ip
export const BASE_URL = "https://admin.blue24llc.com/api/v1/"; //production url
export const SCIENER_URL = "https://api.sciener.com/v3/";
// export const BASE_URL = "http://localhost:8082/api/v1/";
